import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idContactsContactCompetitor']),
        getByWork: state => work => {
            return state.objs.filter(competitor => competitor.work === work);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idContactsContactCompetitor'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idContactsContactCompetitor'])
    },
}